/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_Mock_2_DetailInputs */

const en_cap_full_mock_2_detail = /** @type {(inputs: Cap_Full_Mock_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles, tools, limits`)
};

const lv_cap_full_mock_2_detail = /** @type {(inputs: Cap_Full_Mock_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lomas, rīki, robežas`)
};

/**
* | output |
* | --- |
* | "Roles, tools, limits" |
*
* @param {Cap_Full_Mock_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_mock_2_detail = /** @type {((inputs?: Cap_Full_Mock_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_Mock_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_mock_2_detail(inputs)
	return en_cap_full_mock_2_detail(inputs)
});